import React from 'react';
import { TICKET_STATUSES } from '../../constants/appConstants';
import { formatStatusTitle } from '../../constants/statusConstants';
import styles from './TicketStatusSelect.module.scss';

const TicketStatusSelect = ({ value, onChange, disabled = false, size, style, className = '' }) => (
  <select
    className={`form-select ${styles.select} ${size === 'sm' ? 'btn-sm' : ''} ${className}`}
    value={value}
    onChange={(e) => onChange(e.target.value)}
    disabled={disabled}
    style={style}
  >
    {TICKET_STATUSES.map((status) => (
      <option key={status} value={status}>
        {formatStatusTitle(status)}
      </option>
    ))}
  </select>
);

export default TicketStatusSelect;
